import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import promise from 'redux-promise'
import thunk from 'redux-thunk'
import reducers from './reducers'
import App from './components/App'
import i18n from './i18n'
import * as constants from './services/Constants'

let divId = 'topperf'
let windowEnv = 'tp_env'
const TRUE = 'true'
const FALSE = 'false'

function getSyncScriptParams() {
  const scripts = document.getElementsByTagName('script')
  const lastScript = scripts[scripts.length - 1]
  const scriptName = lastScript
  windowEnv = scriptName.getAttribute('windowEnv') ? scriptName.getAttribute('windowEnv') : 'tp_env'
  divId = scriptName.getAttribute('divId') ? scriptName.getAttribute('divId') : 'topperf'
}

getSyncScriptParams()

const TP_ENV = window[windowEnv] || {}

// window.isFP = FALSE
let wtRegion = 'US'
let wtDivisionID = '1'
let isoCode = 'en-US'
let topn = '5'
let typeCat = ''
let isFP = window.isFP
let showTopnCountButtons = FALSE
let showDatePicker = FALSE
let cobdate = ''
let period = 'ytd'
let isSL = window.isSL
let calendarStart = '20220101'

// for dashboard try window.portfolioMapper
if (window.portfolioMapper) {
  if (window.portfolioMapper.wtRegion) {
    wtRegion = window.portfolioMapper.wtRegion
  }
  if (window.portfolioMapper.wtDivisionID) {
    wtDivisionID = window.portfolioMapper.wtDivisionID
  }
  if (window.portfolioMapper.isoCode) {
    isoCode = window.portfolioMapper.isoCode
  }
}

if (TP_ENV.wtRegion && TP_ENV.wtRegion.toLowerCase() !== 'us' && String(TP_ENV.wtDivisionID) === '2') {
  const accountType = document.body.getAttribute('data-account-type')
  isFP = accountType && accountType.toLowerCase().includes('institutional')
}

const getDefaultPrefCurrency = () => {
  let perfCcy = constants.CUR_USD
  const isoCodeConfig = TP_ENV.isoCode || isoCode
  const divisionID = TP_ENV.wtDivisionID || wtDivisionID

  if (isoCodeConfig === constants.REGION_ISO_GB && String(divisionID) === '2') {
    perfCcy = constants.CUR_GBP
  } else if (isoCodeConfig !== constants.REGION_ISO_GB && String(divisionID) === '2') {
    perfCcy = constants.CUR_EUR
  }

  return perfCcy
}

function getPeriod(value) {
  switch (value) {
    case 'dly':
    case 'mtd':
    case 'qtd':
    case 'ytd':
      return value
    case '3m':
      return 'trailing_03mos_ror'
    case '1y':
      return 'trailing_01years_ror'
    case '3y':
      return 'trailing_03years_ror'
    case '5y':
      return 'trailing_05years_ror'
    case '10y':
      return 'trailing_10years_ror'
    default:
      return 'ytd'
  }
}

const initialState = {
  wtRegion: TP_ENV.wtRegion || wtRegion,
  wtDivisionID: TP_ENV.wtDivisionID || wtDivisionID,
  isoCode: TP_ENV.isoCode || isoCode,
  topn: TP_ENV.topn || topn,
  showTopnNumButtons: TP_ENV.showTopnNumButtons === TRUE || showTopnCountButtons === TRUE,
  showDatePicker: TP_ENV.showDatePicker === TRUE || showDatePicker === TRUE,
  typeCat: TP_ENV.typeCat || typeCat,
  cobdate: TP_ENV.cobdate || cobdate,
  isFP: typeof isFP === 'boolean' ? isFP : TP_ENV.isFP,
  data: [],
  period: getPeriod(`${TP_ENV.period || period}`),
  type: 'Nav',
  levType: i18n.t('Unleveraged'),
  isSL: TP_ENV.isSL || isSL,
  calendarStart: TP_ENV.calendarStart || calendarStart,
  entities: [],
  sortDirection: '',
  sortColumn: '',
  currencyOption: '',
  selectedCurrencyOption: getDefaultPrefCurrency(),
  tier1CatOptions: [],
  selectedTier1CatOptions: [],
  tier2CatOptions: [],
  selectedTier2CatOptions: [],
  timePeriod01_button: true,
  timePeriod03_button: true,
  timePeriod05_button: true,
  timePeriod10_button: true,
  initialLoad: false
}

i18n.changeLanguage(initialState.isoCode)

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(reducers, { performers: initialState }, composeEnhancers(applyMiddleware(promise, thunk)))
const element = document.getElementById(divId)

if (element) {
  const root = createRoot(element)
  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  )
}



// WEBPACK FOOTER //
// ./src/index.js